export const ESTADO_CIVIL =  [{
    id: "1",
    name: "dashboard.profile.passport.marital_status1"
  }, {
    id: "2",
    name: "dashboard.profile.passport.marital_status2"
  }, {
    id: "3",
    name: "dashboard.profile.passport.marital_status3"
  }];

export const GENERO =  [{
    id: "1",
    name: "Masculino"
  }, {
    id: "2",
    name: "Femenino"
  }];

export const HIJOS = [{
    id: "1",
    name: "Si"
  }, {
    id: "2",
    name: "No"
  }];

export const FOOD = [{
    id: "Americana",
    name: "dashboard.profile.passport.food_american"
  }, {
    id: "Arabe",
    name: "dashboard.profile.passport.food_arab"
  }, {
    id: "Argentina",
    name: "dashboard.profile.passport.food_argentinan"
  }, {
    id: "China",
    name: "dashboard.profile.passport.food_chinese"
  }, {
    id: "Española",
    name: "dashboard.profile.passport.food_spanish"
  }, {
    id: "Francesa",
    name: "dashboard.profile.passport.food_french"
  }, {
    id: "Italiana",
    name: "dashboard.profile.passport.food_italian"
  }, {
    id: "Mexicana",
    name: "dashboard.profile.passport.food_mexican"
  }, {
    id: "Oriental",
    name: "dashboard.profile.passport.food_oriental"
  }, {
    id: "Vegetariana",
    name: "dashboard.profile.passport.food_vegan"
  }, {
    id: "Otra",
    name: "dashboard.profile.passport.food_other"
  }];

  export const EMERGENCY_CONTACT = [{
    id: "1",
    name: "dashboard.profile.passport.emergency_contact_1"
  }, {
    id: "2",
    name: "dashboard.profile.passport.emergency_contact_2"
  }, {
    id: "3",
    name: "dashboard.profile.passport.emergency_contact_3"
  }, {
    id: "4",
    name: "dashboard.profile.passport.emergency_contact_4"
  }, {
    id: "5",
    name: "dashboard.profile.passport.emergency_contact_5"
  }, {
    id: "6",
    name: "dashboard.profile.passport.emergency_contact_6"
  }, {
    id: "7",
    name: "dashboard.profile.passport.emergency_contact_7"
  }];


// WEBPACK FOOTER //
// ./src/dashboard/profile/passportOptions.js